export default __webpack_public_path__ + "static/media/okay_mood_face.edf6c8aa.png";